module.exports = __webpack_public_path__ + "static/media/logo.f75b0244.svg";